import * as React from "react";

export const Step2 = () => (
  <svg
    width="100%"
    viewBox="0 0 416 266"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ aspectRatio: "416 / 266" }}
  >
    <g clipPath="url(#clip0_6751_160148)" filter="url(#filter0_i_6751_160148)">
      <rect width="416" height="265.778" fill="white" />
      <path
        d="M127.998 59.5175L128 59.6592H128.142H405.455V289.326H99.5214V45.2148H127.723L127.998 59.5175Z"
        stroke="#DFE4E9"
        strokeWidth="0.288889"
      />
      <rect
        x="109.15"
        y="237.615"
        width="107.504"
        height="5.77778"
        rx="0.577778"
        fill="#ACB4BD"
      />
      <rect
        x="109.15"
        y="244.549"
        width="93.6584"
        height="5.77778"
        rx="0.577778"
        fill="#DFE4E9"
      />
      <rect
        x="109.15"
        y="251.482"
        width="37.4634"
        height="5.77778"
        rx="0.577778"
        fill="#DFE4E9"
      />
      <rect
        x="109.15"
        y="117.004"
        width="13.8452"
        height="4.04444"
        rx="0.577778"
        fill="#DFE4E9"
      />
      <path
        d="M126.861 120.904L396.233 120.76"
        stroke="#DFE4E9"
        strokeWidth="0.288889"
        strokeLinecap="round"
      />
      <rect
        x="109.15"
        y="151.957"
        width="13.8452"
        height="4.04444"
        rx="0.577778"
        fill="#DFE4E9"
      />
      <path
        d="M126.861 155.857L396.233 155.713"
        stroke="#DFE4E9"
        strokeWidth="0.288889"
        strokeLinecap="round"
      />
      <rect
        x="109.15"
        y="186.916"
        width="13.8452"
        height="4.04444"
        rx="0.577778"
        fill="#DFE4E9"
      />
      <path
        d="M126.861 190.816L396.233 190.672"
        stroke="#DFE4E9"
        strokeWidth="0.288889"
        strokeLinecap="round"
      />
      <rect
        x="109.15"
        y="221.869"
        width="13.8452"
        height="4.04444"
        rx="0.577778"
        fill="#DFE4E9"
      />
      <path
        d="M126.861 225.769L396.233 225.625"
        stroke="#DFE4E9"
        strokeWidth="0.288889"
        strokeLinecap="round"
      />
      <rect
        x="131.955"
        y="173.916"
        width="19.5461"
        height="51.7111"
        fill="#1D4ED8"
      />
      <rect
        x="155.574"
        y="124.516"
        width="19.5461"
        height="101.111"
        fill="#1D4ED8"
      />
      <rect
        x="179.191"
        y="147.338"
        width="19.5461"
        height="78.2889"
        fill="#1D4ED8"
      />
      <rect
        x="202.811"
        y="151.383"
        width="19.5461"
        height="74.2444"
        fill="#1D4ED8"
      />
      <rect
        x="226.428"
        y="158.316"
        width="19.5461"
        height="67.3111"
        fill="#1D4ED8"
      />
      <rect
        x="250.047"
        y="132.316"
        width="19.5461"
        height="93.3111"
        fill="#1D4ED8"
      />
      <rect
        x="273.664"
        y="201.359"
        width="19.5461"
        height="24.2667"
        fill="#1D4ED8"
      />
      <rect
        x="297.283"
        y="184.316"
        width="19.5461"
        height="41.3111"
        fill="#1D4ED8"
      />
      <rect
        x="320.9"
        y="151.383"
        width="19.5461"
        height="74.2444"
        fill="#1D4ED8"
      />
      <rect
        x="344.52"
        y="124.516"
        width="19.5461"
        height="101.111"
        fill="#1D4ED8"
      />
      <rect
        x="368.137"
        y="178.826"
        width="19.5461"
        height="46.8"
        fill="#1D4ED8"
      />
      <rect
        x="109.15"
        y="102.271"
        width="35.0201"
        height="5.77778"
        rx="0.577778"
        fill="#DFE4E9"
      />
      <rect
        x="109.15"
        y="68.7598"
        width="264.687"
        height="6.93333"
        rx="0.577778"
        fill="#ACB4BD"
      />
      <rect
        x="109.15"
        y="78.0039"
        width="177.544"
        height="5.77778"
        rx="0.577778"
        fill="#DFE4E9"
      />
      <rect
        x="109.15"
        y="84.9375"
        width="148.225"
        height="5.77778"
        rx="0.577778"
        fill="#DFE4E9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M113.852 50.2246H115.248V56.1589H113.852V50.2246ZM113.504 51.9707H112.107V56.1596H113.504V51.9707ZM111.758 54.0645H110.361V56.1589H111.758V54.0645ZM116.994 53.3672H115.598V56.1598H116.994V53.3672Z"
        fill="#1F2937"
      />
      <rect y="37.8477" width="92.4444" height="227.933" fill="white" />
      <rect
        x="4.33398"
        y="89.2715"
        width="24.8444"
        height="25.4222"
        fill="white"
      />
      <rect
        x="6.35547"
        y="108.049"
        width="20.8"
        height="4.33333"
        rx="0.577778"
        fill="#DFE4E9"
      />
      <g clipPath="url(#clip1_6751_160148)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.222 94.4704C20.222 94.7895 19.9633 95.0481 19.6442 95.0481C19.3251 95.0481 19.0664 94.7895 19.0664 94.4704C19.0664 94.1513 19.3251 93.8926 19.6442 93.8926C19.9633 93.8926 20.222 94.1513 20.222 94.4704ZM19.0673 99.0917C20.0246 99.0917 20.8007 98.3156 20.8007 97.3583C20.8007 96.401 20.0246 95.625 19.0673 95.625C18.11 95.625 17.334 96.401 17.334 97.3583C17.334 98.3156 18.11 99.0917 19.0673 99.0917ZM16.179 96.7809C16.179 97.1 15.9203 97.3587 15.6012 97.3587C15.2821 97.3587 15.0234 97.1 15.0234 96.7809C15.0234 96.4618 15.2821 96.2031 15.6012 96.2031C15.9203 96.2031 16.179 96.4618 16.179 96.7809ZM19.068 101.404C19.3871 101.404 19.6458 101.145 19.6458 100.826C19.6458 100.507 19.3871 100.248 19.068 100.248C18.7489 100.248 18.4902 100.507 18.4902 100.826C18.4902 101.145 18.7489 101.404 19.068 101.404ZM12.1337 101.693C12.1337 102.171 11.7457 102.56 11.2671 102.56C10.7884 102.56 10.4004 102.171 10.4004 101.693C10.4004 101.214 10.7884 100.826 11.2671 100.826C11.7457 100.826 12.1337 101.214 12.1337 101.693ZM13.2884 103.714C13.2884 104.034 13.0297 104.292 12.7106 104.292C12.3915 104.292 12.1328 104.034 12.1328 103.714C12.1328 103.395 12.3915 103.137 12.7106 103.137C13.0297 103.137 13.2884 103.395 13.2884 103.714ZM15.022 103.138C16.2984 103.138 17.3332 102.103 17.3332 100.827C17.3332 99.5503 16.2984 98.5156 15.022 98.5156C13.7457 98.5156 12.7109 99.5503 12.7109 100.827C12.7109 102.103 13.7457 103.138 15.022 103.138ZM23.1119 100.247C23.1119 100.886 22.5945 101.403 21.9563 101.403C21.3181 101.403 20.8008 100.886 20.8008 100.247C20.8008 99.6092 21.3181 99.0918 21.9563 99.0918C22.5945 99.0918 23.1119 99.6092 23.1119 100.247ZM21.9567 96.7806C22.2758 96.7806 22.5345 96.5219 22.5345 96.2028C22.5345 95.8837 22.2758 95.625 21.9567 95.625C21.6376 95.625 21.3789 95.8837 21.3789 96.2028C21.3789 96.5219 21.6376 96.7806 21.9567 96.7806Z"
          fill="#46596B"
        />
      </g>
      <rect
        x="63.2676"
        y="89.2715"
        width="24.8444"
        height="25.4222"
        fill="white"
      />
      <rect
        x="65.2891"
        y="108.049"
        width="20.8"
        height="4.33333"
        rx="0.577778"
        fill="#DFE4E9"
      />
      <g clipPath="url(#clip2_6751_160148)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M81.4677 94.4707H69.9121V96.7818H81.4677V94.4707ZM73.3788 97.3596H69.9121V99.0929H73.3788V97.3596ZM69.9121 99.6699H73.3788V101.403H69.9121V99.6699ZM77.4237 97.3594H73.957V99.0927H77.4237V97.3594ZM73.957 99.6699H77.4237V101.403H73.957V99.6699ZM81.4686 97.3594H78.002V99.0927H81.4686V97.3594ZM78.002 99.6699H81.4686V101.403H78.002V99.6699ZM73.3788 101.982H69.9121V103.716H73.3788V101.982ZM73.957 101.982H77.4237V103.716H73.957V101.982ZM81.4686 101.982H78.002V103.716H81.4686V101.982Z"
          fill="#46596B"
        />
      </g>
      <rect
        x="4.33398"
        y="119.316"
        width="24.8444"
        height="25.4222"
        fill="white"
      />
      <rect
        x="6.35547"
        y="138.094"
        width="20.8"
        height="4.33333"
        rx="0.577778"
        fill="#DFE4E9"
      />
      <g clipPath="url(#clip3_6751_160148)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.9591 124.922L17.9758 124.935L17.9639 124.98L17.9896 125.017L18.0065 125.013L18.044 124.991L18.0577 124.917L18.044 124.892L18.0561 124.839L18.0793 124.83L18.0938 124.87L18.1103 124.888L18.1523 124.892L18.1593 124.966L18.173 125.016L18.1881 125.031L18.254 124.988L18.2905 125.001L18.2989 125.023L18.3362 125.05L18.3311 125.075L18.2825 125.078L18.2545 125.11L18.2451 125.149L18.2662 125.188L18.3122 125.202L18.2914 125.3L18.2962 125.318L18.3835 125.332L18.4726 125.392L18.5032 125.396L18.496 125.376L18.5157 125.323L18.5094 125.275L18.4962 125.265L18.4231 125.255L18.4333 125.225L18.4244 125.204L18.4577 125.187L18.4707 125.162L18.5133 125.162L18.5055 125.128L18.536 125.112L18.555 125.177L18.5901 125.236L18.618 125.219L18.6557 125.235L18.6647 125.269L18.7346 125.263L18.71 125.291L18.6722 125.35L18.6739 125.372L18.7008 125.373L18.7409 125.419L18.7456 125.485L18.7452 125.49L18.7684 125.49L18.8122 125.521L18.9459 125.483L19.0189 125.443L19.0726 125.4L19.1944 125.346L19.3007 125.356L19.349 125.38L19.4179 125.381L19.4526 125.398L19.4873 125.428L19.5507 125.447L19.5637 125.445L19.5798 125.432L19.6099 125.439L19.6262 125.464L19.649 125.49L19.6847 125.485L19.6998 125.478L19.7845 125.488L19.9121 125.472L20.3344 125.646L20.6429 125.957L20.6775 125.965L20.8358 126L20.8431 126.193L20.8524 126.218L20.8898 126.25L20.9112 126.274L20.9462 126.353L20.9729 126.359L20.9975 126.327L21.0302 126.381L21.1284 126.395L21.1393 126.425L21.1173 126.447L21.0975 126.481L21.1176 126.566L21.1198 126.619L21.1457 126.651L21.1869 126.679L21.1863 126.723L21.1528 126.77L21.1135 126.786L21.0368 126.792L20.9642 126.879L20.9262 127.011L20.9056 127.04L20.8572 127.071L20.8373 127.089L20.7891 127.188L20.7474 127.227L20.7463 127.258L20.7184 127.341L20.6646 127.436L20.6444 127.509L20.6264 127.546L20.6141 127.637L20.6423 127.732L20.6677 127.775L20.6845 127.807L20.7087 127.919L20.7185 127.986L20.6937 128.052L20.5796 128.139L20.5714 128.16L20.583 128.202L20.6135 128.212L20.6329 128.178L20.6927 128.178L20.7091 128.163L20.7496 128.152L20.7778 128.143L20.8141 128.171L20.8301 128.213L20.8678 128.199L20.9244 128.187L20.9706 128.157L21.0146 128.194L21.0425 128.205L21.0737 128.203L21.0998 128.167L21.14 128.174L21.2122 128.156L21.2316 128.187L21.2603 128.2L21.2901 128.193L21.2892 128.219L21.3234 128.24L21.3941 128.244L21.4147 128.269L21.5224 128.262L21.5486 128.292L21.5777 128.304L21.6111 128.337L21.6472 128.346L21.6673 128.37L21.7346 128.361L21.7589 128.33L21.8065 128.339L21.819 128.353L21.7909 128.376L21.7964 128.405L21.8447 128.431L21.8556 128.477L21.8272 128.509L21.8049 128.552L21.7912 128.599L21.8141 128.626L21.8023 128.656L21.8062 128.726L21.8623 128.739L21.8985 128.768L21.9168 128.764L21.945 128.796L21.994 128.821L22.0201 128.825L22.0597 128.809L22.0826 128.826L22.1172 128.81L22.1311 128.853L22.1546 128.87L22.2029 128.886L22.2393 128.873L22.2657 128.899L22.3146 128.968L22.3456 128.989L22.3413 129.041L22.3669 129.055L22.4518 129.053L22.4679 129.067L22.4807 129.109L22.5063 129.144L22.549 129.129L22.5611 129.11L22.611 129.115L22.6351 129.097L22.7017 129.1L22.7381 129.081L22.7769 129.03L22.8079 129.038L22.855 129.026L22.8961 129.031L22.8965 129.007L22.9027 128.949L22.8806 128.924L22.8749 128.899L22.898 128.873L22.9095 128.81L22.9247 128.796L22.9202 128.741L22.972 128.748L23.0824 128.783L23.1044 128.77L23.151 128.768L23.1544 128.742L23.1208 128.701L23.1305 128.656L23.187 128.64L23.1925 128.595L23.2381 128.511L23.2441 128.481L23.27 128.468L23.3222 128.476L23.3568 128.437L23.3749 128.432L23.4037 128.448L23.4143 128.475L23.4458 128.512L23.4889 128.543L23.476 128.613L23.5083 128.629L23.5579 128.647L23.5772 128.644L23.618 128.67L23.6417 128.697L23.6807 128.712L23.6684 128.74L23.6776 128.763L23.6712 128.812L23.6477 128.833L23.6372 128.906L23.6054 128.951L23.6192 128.965L23.6255 129.001L23.6155 129.049L23.6271 129.109L23.6031 129.142L23.611 129.166L23.5808 129.191L23.5921 129.217L23.5628 129.307L23.5268 129.337L23.4979 129.34L23.477 129.378L23.5109 129.407L23.5349 129.451L23.5415 129.516L23.4082 129.625L23.435 129.644L23.4648 129.686L23.4565 129.731L23.4178 129.746L23.3872 129.819L23.352 129.841L23.3844 129.898L23.3801 129.954L23.3895 129.972L23.4084 130.011L23.4146 130.051L23.4355 130.059L23.4694 130.045L23.5404 130.04L23.5484 130.032L23.5988 130.068L23.6652 130.137L23.6889 130.147L23.6658 130.192L23.6763 130.261L23.6669 130.316L23.6361 130.363L23.6453 130.405L23.6248 130.444L23.6283 130.465L23.5883 130.475L23.569 130.522L23.5197 130.492L23.463 130.431L23.3994 130.463L23.3595 130.436L23.3173 130.419L23.2611 130.411L23.2554 130.439L23.2195 130.469L23.1777 130.429L23.1345 130.451L23.1244 130.439L23.0879 130.437L23.0872 130.398L23.061 130.347L22.9888 130.317L22.96 130.342L22.9294 130.313L22.9232 130.252L22.9762 130.168L22.9334 130.117L22.916 130.058L22.8694 130.086L22.843 130.14L22.8156 130.123L22.7444 130.108L22.6808 130.145L22.6048 130.167L22.5775 130.19L22.531 130.183L22.4977 130.167L22.4946 130.21L22.4816 130.245L22.494 130.264L22.4763 130.315L22.4251 130.325L22.4455 130.36L22.4023 130.398L22.3918 130.435L22.3728 130.455L22.3277 130.463L22.319 130.492L22.3475 130.517L22.3496 130.557L22.3421 130.599L22.3143 130.613L22.3221 130.686L22.3331 130.712L22.319 130.733L22.3229 130.76L22.343 130.783L22.3452 130.833L22.3131 130.868L22.3131 130.912L22.3568 130.919L22.3689 130.975L22.3816 130.986L22.4211 130.976L22.4307 131.007L22.4675 131L22.492 131.006L22.5152 130.975L22.5798 130.96L22.6225 130.975L22.6344 130.999L22.6362 131.037L22.677 131.032L22.6943 131.066L22.6801 131.085L22.6857 131.142L22.6618 131.166L22.6208 131.161L22.5741 131.199L22.5704 131.233L22.5797 131.272L22.5149 131.317L22.5035 131.393L22.5293 131.438L22.5405 131.479L22.6077 131.521L22.6052 131.537L22.6563 131.574L22.658 131.609L22.6813 131.619L22.6841 131.668L22.7103 131.689L22.7244 131.726L22.7195 131.742L22.646 131.808L22.6309 131.848L22.5892 131.873L22.5616 131.877L22.5185 131.869L22.5011 131.856L22.4648 131.858L22.4299 131.873L22.4005 131.907L22.3639 131.872L22.3182 131.851L22.3465 131.827L22.3481 131.799L22.3699 131.77L22.3489 131.687L22.2736 131.641L22.2129 131.627L22.1725 131.609L22.1595 131.559L22.1866 131.535L22.1692 131.48L22.1243 131.439L22.1408 131.39L22.1729 131.355L22.1657 131.31L22.1396 131.313L22.0764 131.26L22.0503 131.217L22.0601 131.197L22.0416 131.192L21.9839 131.211L21.9548 131.251L21.9302 131.23L21.9032 131.186L21.8303 131.217L21.8198 131.239L21.7819 131.266L21.7454 131.264L21.6714 131.272L21.6345 131.318L21.6021 131.327L21.5807 131.347L21.5259 131.361L21.5078 131.385L21.4805 131.383L21.4438 131.346L21.4007 131.313L21.3772 131.32L21.3384 131.362L21.3503 131.397L21.3206 131.436L21.3471 131.455L21.3424 131.497L21.3233 131.514L21.3118 131.573L21.2759 131.582L21.212 131.554L21.1958 131.528L21.1736 131.558L21.1453 131.559L21.1139 131.586L21.0819 131.603L21.0368 131.593L21.0195 131.597L20.9938 131.565L20.9598 131.56L20.8985 131.564L20.8797 131.546L20.8225 131.515L20.8076 131.531L20.7758 131.506L20.7133 131.423L20.6997 131.399L20.6821 131.314L20.6578 131.294L20.6453 131.259L20.6043 131.244L20.5364 131.206L20.5604 131.149L20.5387 131.046L20.5226 131.03L20.5164 131.008L20.525 130.938L20.536 130.912L20.531 130.82L20.5504 130.792L20.5408 130.744L20.5025 130.746L20.5006 130.727L20.5371 130.725L20.5472 130.623L20.4549 130.667L20.4264 130.708L20.4252 130.761L20.3835 130.805L20.3193 130.777L20.3052 130.737L20.2826 130.729L20.2538 130.682L20.2693 130.642L20.2354 130.616L20.2133 130.639L20.1643 130.641L20.1595 130.631L20.0786 130.639L20.0164 130.671L19.992 130.672L19.9806 130.713L19.9642 130.808L19.9772 130.83L19.9415 130.872L19.8828 130.893L19.8915 130.963L19.9251 130.99L19.9333 131.009L19.967 131.017L19.9851 131.042L19.9888 131.093L19.9696 131.122L19.9944 131.172L19.969 131.217L19.9717 131.242L19.9914 131.286L20.0341 131.296L20.033 131.325L20.0447 131.349L20.0213 131.383L20.0452 131.425L20.0287 131.465L19.9998 131.478L19.9886 131.501L19.9991 131.555L19.9591 131.588L19.9462 131.62L19.9201 131.636L19.9135 131.676L19.8984 131.685L19.8869 131.773L19.8913 131.807L19.881 131.841L19.8477 131.835L19.803 131.855L19.8094 131.877L19.7966 131.919L19.7831 131.935L19.7457 131.946L19.7233 132.01L19.7332 132.039L19.7209 132.077L19.6813 132.118L19.6558 132.11L19.6433 132.108L19.6149 132.116L19.6063 132.149L19.5389 132.188L19.499 132.269L19.4478 132.282L19.4327 132.305L19.4004 132.309L19.3682 132.329L19.3494 132.342L19.4002 132.466L19.4011 132.485L19.3694 132.528L19.3671 132.575L19.3536 132.587L19.3124 132.595L19.2812 132.587L19.248 132.602L19.2157 132.628L19.1803 132.643L19.1795 132.672L19.1568 132.697L19.1509 132.73L19.1969 132.791L19.2025 132.857L19.2147 132.889L19.1829 132.915L19.1624 132.914L19.1501 132.947L19.1134 132.947L19.1149 132.98L19.1004 132.985L19.1094 133.008L19.1703 133.034L19.1804 133.084L19.1652 133.107L19.1964 133.137L19.1863 133.175L19.2188 133.184L19.2583 133.179L19.2788 133.203L19.3108 133.208L19.3082 133.227L19.3617 133.249L19.3628 133.302L19.388 133.317L19.3656 133.365L19.3306 133.407L19.3026 133.408L19.278 133.463L19.2847 133.494L19.2829 133.508L19.2519 133.534L19.236 133.563L19.2433 133.581L19.2223 133.629L19.1782 133.658L19.1229 133.637L19.1097 133.622L19.12 133.584L19.0548 133.577L19.0359 133.595L19.0098 133.578L18.9924 133.549L18.965 133.55L18.9225 133.567L18.9107 133.591L18.8845 133.587L18.8591 133.604L18.8654 133.552L18.9214 133.47L18.9423 133.458L18.9505 133.429L18.9263 133.428L18.9195 133.365L18.8878 133.318L18.8979 133.283L18.8838 133.26L18.8714 133.236L18.8438 133.222L18.7997 133.155L18.8182 133.09L18.8029 133.041L18.7657 133.05L18.7196 133.024L18.6995 133.009L18.6805 132.991L18.6468 132.942L18.613 132.914L18.5884 132.915L18.5588 132.903L18.5034 132.896L18.4732 132.909L18.4951 132.826L18.5074 132.808L18.5343 132.765L18.5764 132.749L18.6024 132.711L18.6081 132.678L18.6246 132.669L18.6218 132.636L18.6513 132.648L18.6832 132.591L18.6756 132.529L18.6195 132.497L18.5632 132.434L18.5347 132.416L18.5156 132.445L18.4644 132.448L18.3808 132.399L18.34 132.324L18.2852 132.377L18.2532 132.434L18.2045 132.415L18.1673 132.413L18.1472 132.376L18.1189 132.383L18.0813 132.366L18.0517 132.319L17.9411 132.327L17.9346 132.278L17.8916 132.234L17.914 132.179L17.8681 132.173L17.8661 132.151L17.8327 132.147L17.8196 132.128L17.8122 132.083L17.794 132.053L17.7644 132.043L17.763 132.017L17.7289 131.994L17.7104 131.963L17.6983 131.902L17.6654 131.886L17.6454 131.893L17.5759 131.854L17.5304 131.848L17.5034 131.837L17.4894 131.786L17.438 131.771L17.4227 131.744L17.4417 131.712L17.4643 131.701L17.4456 131.655L17.4044 131.605L17.3782 131.549L17.4174 131.523L17.4271 131.456L17.4581 131.448L17.4636 131.421L17.4932 131.393L17.4902 131.344L17.4816 131.306L17.5082 131.265L17.4977 131.24L17.4968 131.188L17.4794 131.159L17.511 131.118L17.4862 131.079L17.5023 131.048L17.4673 130.998L17.4792 130.975L17.4693 130.946L17.496 130.911L17.483 130.876L17.4549 130.855L17.4463 130.827L17.4112 130.816L17.3457 130.84L17.3192 130.84L17.2719 130.872L17.2467 130.869L17.1924 130.87L17.1582 130.892L17.1481 130.916L17.0655 130.986L17.0335 130.996L17.0107 130.986L16.9844 131.023L16.9845 131.037L16.9539 131.064L16.9986 131.089L17.0173 131.082L17.0358 131.105L17.0272 131.201L16.9878 131.215L16.9565 131.236L16.9397 131.261L16.9054 131.246L16.877 131.259L16.8834 131.313L16.8439 131.337L16.835 131.362L16.7903 131.363L16.7554 131.39L16.7587 131.425L16.7268 131.455L16.7188 131.501L16.6985 131.515L16.6782 131.532L16.6605 131.523L16.6175 131.553L16.5641 131.56L16.52 131.535L16.502 131.533L16.4401 131.577L16.4178 131.625L16.393 131.631L16.3778 131.657L16.3333 131.689L16.3164 131.715L16.3343 131.743L16.3805 131.751L16.3813 131.764L16.4074 131.764L16.4162 131.812L16.4389 131.823L16.4505 131.852L16.4952 131.867L16.5094 131.931L16.5334 131.97L16.5392 132.021L16.5766 132.06L16.5755 132.084L16.5554 132.096L16.5288 132.147L16.5284 132.172L16.5455 132.213L16.512 132.26L16.4533 132.267L16.4234 132.289L16.4185 132.345L16.4015 132.371L16.3207 132.398L16.2822 132.396L16.2366 132.416L16.1756 132.418L16.1611 132.468L16.1596 132.506L16.1395 132.533L16.1436 132.585L16.1789 132.668L16.138 132.69L16.107 132.724L16.1241 132.753L16.1035 132.778L16.1086 132.809L16.0739 132.807L16.0521 132.862L16.0373 132.879L16.0006 132.863L15.9402 132.878L15.9162 132.872L15.8647 132.879L15.7915 132.874L15.7461 132.955L15.6959 132.976L15.7093 133.019L15.6881 133.045L15.6952 133.084L15.6743 133.092L15.6686 133.14L15.6947 133.181L15.6826 133.21L15.5715 133.204L15.5215 133.181L15.4577 133.223L15.4311 133.19L15.3875 133.163L15.3652 133.137L15.2995 133.12L15.2936 133.147L15.2662 133.175L15.2608 133.194L15.2161 133.195L15.1922 133.176L15.176 133.147L15.1834 133.088L15.1525 133.063L15.1156 133.059L15.0912 133.046L15.0832 133.014L15.0562 132.975L15.0235 132.964L14.9685 132.992L14.9078 132.982L14.8784 132.995L14.8135 132.99L14.7919 132.973L14.7824 132.922L14.7705 132.916L14.7316 132.924L14.6953 132.92L14.6691 132.965L14.6849 133.023L14.6728 133.05L14.6276 133.052L14.596 133.026L14.5651 133.045L14.5396 133.026L14.522 133.055L14.5037 133.055L14.4746 133.07L14.4548 133.093L14.4654 133.139L14.4554 133.15L14.4159 133.144L14.4073 133.158L14.3728 133.16L14.3416 133.211L14.3191 133.232L14.2694 133.261L14.2417 133.249L14.2278 133.278L14.1825 133.315L14.1326 133.281L14.1178 133.285L14.0661 133.233L14.0246 133.253L13.986 133.248L13.9801 133.227L13.9354 133.224L13.9139 133.204L13.8858 133.23L13.8597 133.296L13.8435 133.3L13.7988 133.351L13.7762 133.329L13.7489 133.343L13.7115 133.334L13.6752 133.348L13.673 133.37L13.6436 133.386L13.6179 133.429L13.6275 133.461L13.5962 133.48L13.5492 133.462L13.508 133.424L13.5152 133.401L13.4829 133.39L13.4271 133.419L13.4153 133.445L13.374 133.478L13.3228 133.478L13.2952 133.422L13.3049 133.405L13.2579 133.364L13.2477 133.32L13.2098 133.3L13.2106 133.258L13.1759 133.231L13.1508 133.201L13.1415 133.164L13.1226 133.131L13.1314 133.103L13.1285 133.062L13.0697 133.036L13.0412 132.995L13.0464 132.978L13.0777 132.965L13.0815 132.946L13.0504 132.916L13.0457 132.873L13.0127 132.865L12.9669 132.839L12.9553 132.772L12.9002 132.727L12.8599 132.634L12.8393 132.637L12.8175 132.619L12.8229 132.58L12.8092 132.568L12.7805 132.577L12.7353 132.639L12.6916 132.65L12.6792 132.675L12.6334 132.652L12.6256 132.617L12.6492 132.556L12.6818 132.537L12.6723 132.516L12.6827 132.488L12.6557 132.443L12.6935 132.386L12.6872 132.365L12.7062 132.316L12.6786 132.31L12.6537 132.321L12.6352 132.309L12.5592 132.305L12.5292 132.281L12.4612 132.285L12.4265 132.263L12.3957 132.26L12.3729 132.183L12.3787 132.144L12.4193 132.102L12.4401 132.064L12.4235 131.998L12.413 131.968L12.433 131.921L12.4684 131.879L12.4656 131.85L12.4954 131.831L12.5153 131.803L12.5248 131.769L12.5706 131.741L12.5688 131.723L12.5855 131.692L12.5827 131.657L12.6003 131.627L12.5823 131.584L12.5463 131.586L12.5071 131.542L12.494 131.515L12.4613 131.474L12.4224 131.45L12.4042 131.454L12.3913 131.397L12.3545 131.396L12.3389 131.345L12.3248 131.333L12.3118 131.298L12.3155 131.271L12.3435 131.248L12.3771 131.245L12.4138 131.203L12.4202 131.175L12.4076 131.158L12.4181 131.126L12.4666 130.98L12.041 130.86L11.5435 130.851L11.2577 131.03L10.9812 131.084L10.7298 131.275L10.6944 131.349L10.6648 131.412L10.6277 131.489L10.6945 131.521L10.7122 131.54L10.7245 131.595L10.7033 131.607L10.6837 131.622L10.6833 131.645L10.7209 131.708L10.754 131.74L10.7712 131.772L10.8266 131.742L10.8591 131.736L10.8997 131.74L10.9048 131.788L10.8567 131.872L10.8483 131.879L10.8014 131.915L10.7683 131.923L10.717 131.96L10.7055 131.953L10.6723 131.954L10.6408 131.976L10.6115 132.009L10.5888 132.016L10.5631 132.053L10.5254 132.078L10.5338 132.131L10.4928 132.166L10.4219 132.195L10.405 132.22L10.3894 132.215L10.3709 132.241L10.2596 132.229L10.2373 132.195L10.1844 132.205L10.1152 132.197L10.1027 132.242L10.0543 132.249L10.0311 132.243L10.0032 132.233L9.96802 132.238L9.93811 132.227L9.90369 132.237L9.88422 132.278L9.85038 132.292L9.82227 132.281L9.85238 132.258L9.84848 132.225L9.88384 132.157L9.90108 132.102L9.92073 132.111L9.933 132.084L9.9419 132.057L9.93004 132.037L9.84554 131.995L9.87383 131.971L9.86259 131.953L9.8904 131.908L9.93553 131.914L9.95677 131.893L9.9775 131.879L9.9871 131.854L10.0335 131.836L10.0596 131.813L10.0982 131.844L10.1434 131.783L10.1694 131.801L10.2259 131.775L10.2678 131.817L10.2898 131.807L10.3343 131.759L10.3236 131.713L10.2733 131.637L10.2695 131.608L10.3027 131.567L10.3269 131.554L10.3228 131.487L10.341 131.464L10.3584 131.433L10.3821 131.389L10.3803 131.368L10.4125 131.353L10.4396 131.317L10.4437 131.287L10.4767 131.248L10.4413 131.19L10.4146 131.2L10.3718 131.154L10.3037 131.1L10.2791 131.101L10.2568 131.062L10.1523 131.028L10.1855 130.959L10.2138 130.925L10.2146 130.891L10.1855 130.864L10.1792 130.809L10.2535 130.739L10.3019 130.614L10.3769 130.522L10.3974 130.534L10.4255 130.496L10.4107 130.483L10.4349 130.457L10.2957 130.318L10.3287 130.285L10.3421 130.261L10.381 130.227L10.4266 130.198L10.4494 130.171L10.5042 130.143L10.5079 130.125L10.5557 130.09L10.5675 130.063L10.5927 130.055L10.6274 130.015L10.6527 130.001L10.6706 129.971L10.7744 129.875L10.7802 129.847L10.822 129.813L10.8963 129.777L10.9474 129.744L11.0021 129.725L11.0339 129.703L11.0578 129.668L11.093 129.662L11.0878 129.636L11.135 129.628L11.1537 129.601L11.1441 129.579L11.1815 129.545L11.2318 129.536L11.2736 129.517L11.2999 129.492L11.2983 129.476L11.3374 129.442L11.3377 129.421L11.358 129.378L11.2852 129.317L11.2741 129.271L11.3037 129.253L11.3004 129.218L11.3093 129.184L11.3628 129.096L11.3714 128.989L11.3764 128.923L11.3561 128.876L11.2888 128.784L11.2795 128.753L11.3162 128.731L11.3612 128.688L11.3984 128.632L11.4423 128.581L11.475 128.549L11.5033 128.585L11.542 128.564L11.6792 128.526L11.7661 128.475L11.779 128.467L11.8425 128.471L11.8938 128.441L11.9245 128.405L11.9695 128.316L12.029 128.276L12.0933 128.26L12.1568 128.2L12.1236 128.175L12.0995 128.171L12.0714 128.137L12.1142 128.104L12.105 128.069L12.1448 128.038L12.1758 128.023L12.2158 128.029L12.2373 128.002L12.2187 127.948L12.2956 127.896L12.3267 127.892L12.3788 127.866L12.4175 127.851L12.4483 127.828L12.4896 127.779L12.555 127.734L12.5823 127.694L12.5405 127.689L12.5285 127.667L12.5972 127.628L12.6275 127.585L12.6466 127.538L12.6756 127.516L12.7394 127.457L12.7808 127.439L12.7921 127.411L12.8284 127.399L12.8386 127.384L12.8401 127.367L12.8775 127.346L12.8501 127.299L12.8642 127.271L12.8667 127.229L12.8325 127.15L12.8706 127.124L12.9174 127.122L12.942 127.106L13.0031 127.107L13.0238 127.083L13.0362 127.084L13.0632 127.027L13.0434 126.98L13.1189 126.962L13.1534 126.969L13.1867 126.935L13.202 126.893L13.1662 126.877L13.1744 126.857L13.1632 126.811L13.119 126.804L13.1165 126.784L13.0514 126.762L13.0323 126.786L13.0014 126.804L12.9619 126.804L12.9355 126.82L12.8651 126.821L12.8356 126.831L12.8087 126.827L12.7724 126.841L12.7136 126.822L12.6614 126.852L12.6436 126.831L12.6616 126.788L12.658 126.761L12.6944 126.73L12.7238 126.717L12.7497 126.687L12.7551 126.652L12.7717 126.616L12.8259 126.611L12.8353 126.568L12.8277 126.488L12.9025 126.479L12.9228 126.428L12.9569 126.419L12.9839 126.424L13.0184 126.398L13.017 126.361L13.0147 126.338L12.9725 126.296L12.9784 126.247L12.9718 126.218L13.0162 126.189L13.0882 126.17L13.1267 126.2L13.1983 126.211L13.2317 126.224L13.2425 126.242L13.2939 126.212L13.3556 126.211L13.405 126.173L13.4357 126.18L13.4737 126.202L13.5008 126.231L13.5313 126.237L13.6284 126.217L13.5971 126.242L13.5566 126.333L13.5603 126.351L13.5586 126.378L13.5346 126.444L13.6014 126.465L13.6134 126.48L13.6441 126.483L13.7032 126.461L13.7348 126.474L13.743 126.51L13.7627 126.519L13.7644 126.548L13.7906 126.532L13.8405 126.518L13.8774 126.484L13.9069 126.491L13.9398 126.465L14.0117 126.46L14.0491 126.455L14.0751 126.48L14.178 126.496L14.2375 126.48L14.2566 126.459L14.3011 126.431L14.3235 126.399L14.3284 126.373L14.3741 126.362L14.4054 126.323L14.3703 126.286L14.3262 126.268L14.3145 126.241L14.3428 126.198L14.4035 126.237L14.4264 126.238L14.4532 126.277L14.5043 126.269L14.5345 126.238L14.5757 126.203L14.5755 126.177L14.5703 126.146L14.5529 126.123L14.5934 126.112L14.6152 126.12L14.6384 126.064L14.6272 126.043L14.5917 126.042L14.5722 126.06L14.5496 126.061L14.5398 126.009L14.556 125.995L14.601 125.981L14.6193 125.956L14.7108 125.898L14.7179 125.861L14.7448 125.84L14.8015 125.848L14.8144 125.783L14.863 125.806L14.8617 125.838L14.9062 125.842L14.9228 125.83L14.9799 125.777L14.9879 125.751L15.0535 125.773L15.0958 125.824L15.1029 125.868L15.0624 125.892L15.0151 125.907L14.9951 125.919L14.9521 125.913L14.9864 125.952L15.0054 125.977L15.0356 125.987L15.0521 126.024L15.078 126.038L15.1115 126.042L15.1443 126.041L15.1957 126.011L15.2271 125.998L15.3146 125.986L15.3304 125.971L15.4083 125.949L15.4461 125.93L15.4577 125.906L15.496 125.87L15.5168 125.796L15.5594 125.798L15.5742 125.816L15.6036 125.817L15.6442 125.795L15.7193 125.788L15.7588 125.81L15.7849 125.842L15.8002 125.878L15.7876 125.915L15.791 125.939L15.8176 125.974L15.8638 125.977L15.8888 125.988L15.9137 125.984L15.9344 125.931L15.9628 125.931L16.0034 125.94L16.0681 125.935L16.0928 125.941L16.0958 125.943L16.1304 125.961L16.2114 125.939L16.2519 125.903L16.2888 125.9L16.3262 125.93L16.3678 125.914L16.3808 125.89L16.3855 125.846L16.4153 125.812L16.4562 125.813L16.4877 125.81L16.4937 125.779L16.521 125.76L16.5574 125.764L16.5768 125.763L16.604 125.729L16.6346 125.716L16.6635 125.664L16.6872 125.646L16.7249 125.647L16.7471 125.667L16.7556 125.707L16.7718 125.713L16.799 125.68L16.8607 125.669L16.869 125.677L16.8812 125.695L16.9261 125.685L16.9526 125.691L16.9806 125.713L16.9726 125.762L16.9825 125.788L17.0378 125.833L17.0626 125.861L17.1015 125.871L17.1777 125.875L17.2432 125.893L17.2694 125.85L17.292 125.841L17.3433 125.87L17.3743 125.884L17.4072 125.886L17.4644 125.862L17.4895 125.863L17.5284 125.838L17.5495 125.84L17.5592 125.838L17.5825 125.823L17.5595 125.795L17.5039 125.81L17.4679 125.75L17.4666 125.727L17.5017 125.721L17.5314 125.689L17.548 125.676L17.6245 125.658L17.6216 125.63L17.6495 125.593L17.7158 125.597L17.7171 125.62L17.7745 125.627L17.8022 125.693L17.7913 125.74L17.851 125.755L17.8915 125.713L17.9155 125.687L17.9201 125.665L17.897 125.607L17.8906 125.545L17.9285 125.5L17.9473 125.538L17.9186 125.55L17.9249 125.57L17.9765 125.552L17.9915 125.517L17.9905 125.497L17.9492 125.459L17.9244 125.425L17.899 125.408L17.8861 125.434L17.8368 125.459L17.7968 125.442L17.7938 125.421L17.7434 125.434L17.7217 125.443L17.7259 125.48L17.6818 125.464L17.7014 125.509L17.6956 125.531L17.6687 125.534L17.64 125.523L17.5782 125.525L17.531 125.536L17.4998 125.551L17.4885 125.518L17.4435 125.49L17.4059 125.478L17.3659 125.435L17.3313 125.438L17.3105 125.401L17.3567 125.358L17.3306 125.311L17.3071 125.294L17.3449 125.24L17.3726 125.235L17.4318 125.181L17.4623 125.183L17.4677 125.153L17.4454 125.112L17.4643 125.091L17.4674 125.061L17.4972 125.041L17.5189 124.992L17.5657 124.953L17.5871 124.965L17.6301 124.94L17.6607 124.966L17.6802 124.931L17.6991 124.932L17.7603 124.902L17.8016 124.932L17.8349 124.916L17.8283 124.879L17.7879 124.865L17.7935 124.808L17.8225 124.805L17.8292 124.833L17.8675 124.82L17.8818 124.837L17.9091 124.819L17.9472 124.827L17.9724 124.856L17.9508 124.9L17.9591 124.922Z"
          fill="#46596B"
        />
      </g>
      <rect
        x="63.2676"
        y="58.9355"
        width="24.8444"
        height="25.4222"
        fill="white"
      />
      <rect
        x="65.2891"
        y="78.002"
        width="20.8"
        height="4.33333"
        rx="0.577778"
        fill="#DFE4E9"
      />
      <g clipPath="url(#clip4_6751_160148)">
        <g clipPath="url(#clip5_6751_160148)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M77.4229 70.4878L82.0451 67.8878V63.2656L77.4229 67.599L73.3784 66.4434L69.334 70.4878V71.6434L73.3784 69.0434L77.4229 70.4878ZM82.0451 73.0871V68.4648L77.4229 71.0648L73.3784 69.6204L69.334 72.2204V73.0871H82.0451Z"
            fill="#46596B"
          />
        </g>
      </g>
      <rect
        x="33.8008"
        y="89.2715"
        width="24.8444"
        height="25.4222"
        fill="white"
      />
      <rect
        x="35.8223"
        y="108.049"
        width="20.8"
        height="4.33333"
        rx="0.577778"
        fill="#DFE4E9"
      />
      <g clipPath="url(#clip6_6751_160148)">
        <g clipPath="url(#clip7_6751_160148)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M48.6345 94.4606C47.9686 94.121 47.2505 93.9357 46.5117 93.8945V97.7945L48.9672 94.6483C48.8595 94.5823 48.7486 94.5197 48.6345 94.4606ZM49.5343 95.0508L46.5117 98.8054L50.9479 101.116L51.0391 100.947C51.9186 98.7991 51.3312 96.4485 49.5343 95.0508ZM45.9345 93.8926V99.0926L50.5568 101.693C49.6456 103.313 47.9666 104.293 46.1443 104.293C45.3253 104.293 44.5062 104.095 43.7691 103.709C42.5611 103.063 41.6704 101.969 41.2609 100.645C40.8514 99.3114 40.9742 97.9046 41.609 96.6749C42.4213 95.1029 43.9606 94.0608 45.6784 93.9014L45.9345 93.8926Z"
            fill="#46596B"
          />
        </g>
      </g>
      <rect
        x="33.8008"
        y="59.2246"
        width="24.8444"
        height="25.4222"
        rx="1.15556"
        fill="white"
      />
      <rect
        x="35.8223"
        y="78.002"
        width="20.8"
        height="4.33333"
        rx="0.577778"
        fill="#DFE4E9"
      />
      <g clipPath="url(#clip8_6751_160148)">
        <g clipPath="url(#clip9_6751_160148)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M45.3549 67.8471L40.8523 72.3497L40.0352 71.5326L45.3549 66.2129L47.3771 68.2352L51.5908 64.0215L52.4079 64.8386L47.3771 69.8694L45.3549 67.8471ZM52.4069 69.4618L51.5898 68.6447L47.9539 72.2806L44.8463 69.173L44.0293 69.99L47.9539 73.9148L52.4069 69.4618ZM41.5993 67.5602L42.3957 68.3564L43.2126 67.5394L41.5993 65.926L40.0352 67.4901L40.8523 68.3072L41.5993 67.5602Z"
            fill="#46596B"
          />
        </g>
      </g>
      <rect
        x="4.33398"
        y="59.2246"
        width="24.8444"
        height="25.4222"
        rx="0.577778"
        fill="#1F2937"
      />
      <rect
        x="6.35547"
        y="78.002"
        width="20.8"
        height="4.33333"
        rx="0.577778"
        fill="#F3F4F6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0449 64.4277H19.356V74.25H17.0449V64.4277ZM16.4676 67.3166H14.1565V74.25H16.4676V67.3166ZM13.5787 70.7833H11.2676V74.25H13.5787V70.7833ZM22.2447 69.627H19.9336V74.2492H22.2447V69.627Z"
        fill="white"
      />
      <rect
        x="4.33398"
        y="44.4922"
        width="29.4667"
        height="6.35556"
        rx="0.577778"
        fill="#DFE4E9"
      />
      <g
        clipPath="url(#clip10_6751_160148)"
        filter="url(#filter1_i_6751_160148)"
      >
        <rect y="11.5566" width="416" height="27.7333" fill="white" />
        <g clipPath="url(#clip11_6751_160148)">
          <rect y="11.5566" width="416" height="27.7333" fill="white" />
        </g>
        <path
          d="M15.5853 20.6574C15.5853 20.6574 13.9707 19.9336 11.2676 19.9336H11.2667C8.56334 19.9336 6.94846 20.6574 6.94846 20.6574C6.94846 20.6574 6.80384 23.8622 7.41669 25.6744C8.4992 28.8609 11.2662 29.7558 11.2662 29.7558H11.267H11.2679C11.2679 29.7558 14.0343 28.8609 15.1174 25.6744C15.7302 23.8622 15.5853 20.6574 15.5853 20.6574Z"
          fill="#D8232A"
        />
        <path
          d="M14.1567 23.4008V25.1343H12.1345V27.1567H10.4011V25.1343H8.37891V23.4008H10.4011V21.3789H12.1342L12.1345 23.4008H14.1567Z"
          fill="white"
        />
      </g>
      <rect y="0.00195312" width="416" height="11.5556" fill="#2F4356" />
      <circle cx="8.95582" cy="5.78004" r="2.02222" fill="#D8232A" />
      <circle cx="15.3113" cy="5.78004" r="2.02222" fill="#F7B500" />
      <circle cx="21.6668" cy="5.78004" r="2.02222" fill="#6DD400" />
    </g>
    <defs>
      <filter
        id="filter0_i_6751_160148"
        x="0"
        y="0"
        width="416"
        height="265.777"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.87451 0 0 0 0 0.894118 0 0 0 0 0.913725 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_6751_160148"
        />
      </filter>
      <filter
        id="filter1_i_6751_160148"
        x="0"
        y="11.5566"
        width="416"
        height="27.7324"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.87451 0 0 0 0 0.894118 0 0 0 0 0.913725 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_6751_160148"
        />
      </filter>
      <clipPath id="clip0_6751_160148">
        <rect width="416" height="265.778" fill="white" />
      </clipPath>
      <clipPath id="clip1_6751_160148">
        <rect
          width="13.8667"
          height="13.8667"
          fill="white"
          transform="translate(9.82227 92.1602)"
        />
      </clipPath>
      <clipPath id="clip2_6751_160148">
        <rect
          width="13.8667"
          height="13.8667"
          fill="white"
          transform="translate(68.7559 92.1602)"
        />
      </clipPath>
      <clipPath id="clip3_6751_160148">
        <rect
          width="13.8667"
          height="13.8667"
          fill="white"
          transform="translate(9.82227 122.205)"
        />
      </clipPath>
      <clipPath id="clip4_6751_160148">
        <rect
          width="13.8667"
          height="13.8667"
          fill="white"
          transform="translate(68.7559 60.957)"
        />
      </clipPath>
      <clipPath id="clip5_6751_160148">
        <rect
          width="13.8667"
          height="13.8667"
          fill="white"
          transform="translate(68.7559 60.9551)"
        />
      </clipPath>
      <clipPath id="clip6_6751_160148">
        <rect
          width="13.8667"
          height="13.8667"
          fill="white"
          transform="translate(39.2891 92.1602)"
        />
      </clipPath>
      <clipPath id="clip7_6751_160148">
        <rect
          width="13.8667"
          height="13.8667"
          fill="white"
          transform="translate(39.2891 92.1582)"
        />
      </clipPath>
      <clipPath id="clip8_6751_160148">
        <rect
          width="13.8667"
          height="13.8667"
          fill="white"
          transform="translate(39.2891 62.1133)"
        />
      </clipPath>
      <clipPath id="clip9_6751_160148">
        <rect
          width="13.8667"
          height="13.8667"
          fill="white"
          transform="translate(39.2891 62.1152)"
        />
      </clipPath>
      <clipPath id="clip10_6751_160148">
        <rect
          width="416"
          height="27.7333"
          fill="white"
          transform="translate(0 11.5566)"
        />
      </clipPath>
      <clipPath id="clip11_6751_160148">
        <rect
          width="416"
          height="27.7333"
          fill="white"
          transform="translate(0 11.5566)"
        />
      </clipPath>
    </defs>
  </svg>
);
